<div *ngIf="!config.multiCheck">
<div [formGroup]="group" class="dynamic-radio {{config.class}}">
  <mat-label class="default-sub-header text-label">{{config.label | translate}}</mat-label> 
  <mat-radio-group [formControlName]="config.name"  [attr.name]="config.name" (change)="selectedOption($event)">  
  <mat-radio-button class="radio-button" *ngFor="let option of config.options" [value]='option.id' [disabled] = 'config.disabled' > 
    <div class="selection-container " [ngClass]="{'icon-Check---Widget': dfs.selectedRadioOption == option.id}"></div>   
    <span class="default-form-field">{{option.value | translate}}</span>
  </mat-radio-button>
</mat-radio-group>
</div>
</div>
<div *ngIf="config.multiCheck">
<mat-radio-group aria-label="Select an option" [formGroup]="group">
  <mat-radio-button class="radio-button" *ngFor="let option of config.options" [value]='option.id' [disabled] = 'config.disabled' > 
    <div class="selection-container " [ngClass]="{'icon-Check---Widget': dfs.selectedRadioOption == option.id}"></div>   
    <span class="default-form-field">{{option.value}}</span>
  </mat-radio-button>
</mat-radio-group>
</div>